<ng-container *ngIf="showDropDownMenu">
  <gd-dropdown-menu
    #dropdownMenu
    [buttonType]="buttonType"
    [buttonContent]="buttonContent || defaultButtonContent"
    [dropdownTpl]="dropdownTpl"
    [isMobile]="isMobile"
    [positionLeft]="positionLeft"
    [mobileMenuTitle]="'txt_add_products'"
    [isDisabled]="disabled"
    [triggerElementRef]="triggerElementRef"
    (menuButtonClick)="addButtonClick()"
  >
  </gd-dropdown-menu>

  <ng-template #defaultButtonContent> {{ 'txt_add_product' | translate }} </ng-template>

  <ng-template #dropdownTpl>
    <a *ngIf="canCreateDesign" class="item dropdown" (click)="createDesign()">
      <img [src]="'sdk/pen.svg' | assetsPath | async" alt="" />{{ 'txt_create_design' | translate }}
    </a>
    <a *ngIf="showUploadDesign" class="item dropdown cy-upload-design-menu-item d-flex" (click)="uploadDesign()">
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            iconPath: 'icons/products-catalog.svg',
            description: 'txt_multiple_products_description',
            title: 'txt_multiple_products'
          }
        "
      ></ng-container>
    </a>
    <a
      *ngIf="canAddNewProduct"
      class="item dropdown cy-add-product-menu-item"
      uiLogEvent
      analyticsKey="CreateNewProduct"
      (click)="onAddNewProductClick($event)"
    >
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            iconPath: 'icons/single-product.svg',
            description: 'txt_single_product_description',
            title: 'txt_single_product'
          }
        "
      ></ng-container>
    </a>
    <a *ngIf="canUseTemplate" class="item dropdown cy-use-template-menu-item" (click)="useTemplate()">
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            iconPath: 'sidebar-icons/templates.svg',
            title: 'txt_use_a_template',
            description: 'txt_select_a_template'
          }
        "
      ></ng-container>
    </a>
    <a *ngIf="canPlaceAnOrder" class="item dropdown cy-place-order-menu-item" (click)="onPlaceOrder()">
      <img [src]="'icons/place-order.svg' | assetsPath | async" alt="place order" />
      {{ 'txt_header_create_menu_item_place_order_order' | translate }}
    </a>
    <a
      *ngIf="canAddExistingProduct"
      class="item dropdown cy-select-product-from-my-stores-menu-item"
      uiLogEvent
      analyticsKey="SelectExistingProduct"
      (click)="onAddExistingProductClick($event)"
    >
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            iconPath: 'icons/product-add-menu/copy.svg',
            description: 'txt_select_from_other_store_description',
            title: 'txt_select_from_other_store'
          }
        "
      ></ng-container>
    </a>
    <a
      *ngIf="canConnectExistingProducts"
      class="item dropdown cy-connect-existing-stores-menu-item"
      uiLogEvent
      analyticsKey="SelectExistingProduct"
      (click)="onConnectExistingProductsClick($event)"
    >
      <img [src]="'icons/product-add-menu/connect.svg' | assetsPath | async" alt="" />{{
        'txt_connect_existing_products' | translate
      }}
    </a>

    <div
      *ngIf="showAddBranding"
      class="item dropdown"
      suiPopup
      [popupBasic]
      [popupInverted]
      [popupText]="'txt_disabled_add_branding_tooltip' | translate"
      [popupPlacement]="isMobile ? 'top' : 'right'"
      [ngClass]="{ 'item-disabled': !connectedItems?.length }"
      (click)="addBranding()"
    >
      <img [src]="'sidebar-icons/branding.svg' | assetsPath | async" alt="" />
      {{ 'txt_add_branding' | translate }}
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="!showDropDownMenu">
  <button
    *ngIf="canAddNewProduct"
    class="ui button {{ buttonType }} cy-add-product-button"
    [class.loading]="isLoading"
    uiLogEvent
    analyticsKey="CreateNewProduct"
    (click)="onAddNewProductClick($event)"
    data-lokalise
    data-key="txt_create_new"
  ></button>
  <button
    *ngIf="canAddExistingProduct"
    class="ui button {{ buttonType }} cy-add-product-button"
    [class.loading]="isLoading"
    uiLogEvent
    analyticsKey="SelectExistingProduct"
    (click)="onAddExistingProductClick($event)"
    data-lokalise
    data-key="txt_select_from_other_store"
  ></button>
  <button
    *ngIf="canConnectExistingProducts"
    class="ui button {{ buttonType }} cy-add-product-button"
    [class.loading]="isLoading"
    uiLogEvent
    analyticsKey="ConnectExistingProducts"
    (click)="onConnectExistingProductsClick($event)"
    data-lokalise
    data-key="txt_connect_existing_products"
  ></button>
</ng-container>

<ng-template #item let-icon="iconPath" let-description="description" let-title="title">
  <img [src]="icon | assetsPath | async" alt="Upload design" />

  <div>
    <div *ngIf="title" [innerHTML]="title | translate | safe: 'html'"></div>
    <div *ngIf="description" class="item-description" [innerHTML]="description | translate | safe: 'html'"></div>
  </div>
</ng-template>
